import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: none;

  @media ${({ theme }) => `${theme.breakpoints.desktop}`} {
    margin: 0;
    font-size: 12px;
    background: #f2f2f2;
    width: 100%;
    display: block;
    height: 21px;
  }
`;
const Content = styled.div`
  max-width: ${props => (props.maxWidth ? props.maxWidth : '1267px')};
  margin: 0 auto;
  text-align: right;
  padding: 3.5px 32px;
`;

const Item = styled.div`
  display: inline-block;
  margin-left: 10px;
`;

const Dot = styled.span`
  margin-right: 10px;
`;

const Link = styled.a`
  text-decoration: none;
  color: #213038;
  &:hover {
    text-decoration: underline;
  }
`;

function HeaderTopBar(props) {
  return props.data ? (
    <Wrapper>
      <Content maxWidth={props.maxWidth}>
        {props.data.map((item, key) => (
          <Item key={key}>
            {key !== 0 && <Dot>&#8226;</Dot>}
            <Link href={item.link}>{item.label}</Link>
          </Item>
        ))}
      </Content>
    </Wrapper>
  ) : null;
}

HeaderTopBar.displayName = 'HeaderTopBar';

HeaderTopBar.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, link: PropTypes.string })
  ),
  maxWidth: PropTypes.string
};

HeaderTopBar.defaultProps = {
  data: [],
  maxWidth: '1267px'
};

export default HeaderTopBar;
